import React, { useState, useRef, useEffect } from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";

import person1 from "../assets/images/person4.png";
import person2 from "../assets/images/person5.png";
import person3 from "../assets/images/person6.png";


import talent1 from "../assets/images/talent1.png";
import talent2 from "../assets/images/talent2.png";
import talent3 from "../assets/images/talent3.png";
import talent4 from "../assets/images/talent4.png";

import whyChoose1 from "../assets/images/whyChoose1.jpeg";
import whyChoose2 from "../assets/images/whyChoose2.jpeg";

import arrowLeft from "../assets/images/arrowLeft.png";
import arrowRight from "../assets/images/ArrowRight.png";

import design from "../assets/images/design.png";
import decoration from "../assets/images/decoration.png";

import rocket from "../assets/images/rocket.png";

import { MdArrowOutward } from "react-icons/md";

import tick from "../assets/images/tick.png";

import CountUp from "react-countup";

import Slider from "react-slick";

import { Helmet } from "react-helmet";
import ApiService from "../services/ApiService";
import { User } from "lucide-react";
import { Carousel, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
  const { t, i18n } = useTranslation();

  const talents = [
    {
      name: "Muhammad Salman",
      role: "Product Designer",
      img: talent1,
      category: "Design",
    },
    {
      name: "Muhammad Abou",
      role: "Software Developer",
      img: talent2,
      category: "Development",
    },
    {
      name: "Muhammad Salman",
      role: "UIUX Designer",
      img: talent3,
      category: "Design",
    },
    {
      name: "Musa Janat",
      role: "Web Developer",
      img: talent4,
      category: "Development",
    },
    {
      name: "Musa Janat",
      role: "Web Developer",
      img: talent4,
      category: "Development",
    },
  ];
  const [homeData, setHomeData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const sliderRef = useRef(null);
  const teamSliderRef = useRef(null);
  const settings = {
    dots: false,
    arrows: false, // Hide default arrows
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const navigate = useNavigate();
  const [errors, setErrors] = useState({ name: "", email: "", message: "" });
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name.trim()) {
      setErrors((prev) => ({ ...prev, name: "Name is required" }));
      return;
    }
    if (!isValidEmail(formData.email)) {
      setErrors((prev) => ({ ...prev, email: "Invalid email address" }));
      return;
    }
    if (!formData.message.trim()) {
      setErrors((prev) => ({ ...prev, message: "Message is required" }));
      return;
    }

    console.log("Submitting form:", formData, "For member:", selectedMember);

    setIsLoading(true); // Set loading state

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("name", formData.name);
    formDataToSubmit.append("email", formData.email);
    formDataToSubmit.append("message", formData.message);
    formDataToSubmit.append("team_id", selectedMember?._id || ""); // Assuming 'id' is the team ID for the selected member

    try {
      const response = await ApiService.request({
        method: "POST", // POST request for submitting the form
        url: "/submitTeamLead", // The endpoint for submitting the message
        headers: {
          Accept: "application/json",
          Language: "en", // Add any necessary headers
        },
        data: formDataToSubmit, // Send the form data
      });

      // Handle the response
      if (response.status === 200) {
        console.log("Message sent successfully:", response.data);
        // Optionally show a success message, or clear the form
        setShowSuccessModal(true);
      } else {
        console.error("Failed to send message:", response.data);
        // Handle failure case
      }
    } catch (error) {
      console.error("Error while sending message:", error);
      // Handle error case
    } finally {
      setIsLoading(false); // Reset loading state
      setShowModal(false); // Close the modal after submission
      setFormData({ name: "", email: "", message: "", team_id: "" }); // Reset form
    }
  };

  const members = homeData?.teams?.length ? homeData.teams : talents;
  // const members =  talents;

  const slidesToShowCount = Math.min(homeData?.teams?.length || 0, 4);

  const teamSettings = {
    infinite: homeData?.teams?.length > slidesToShowCount,
    slidesToShow: slidesToShowCount,
    slidesToScroll: 1,
    centerMode: false,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(homeData?.teams?.length || 0, 2),
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const slides = [
    {
      title: "our_vision",
      heading: "a_s1_vision_heading",
      description: "a_s1_vision_desc",
    },
    {
      title: "our_mission",
      heading: "a_s1_mission_heading",
      description: "a_s1_mission_desc",
    },
  ];
  const [activeTab, setActiveTab] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchHome = async () => {
    setIsLoading(true);
    try {
      const response = await ApiService.request({
        method: "GET",
        url: `/getTeamMembers`,
      });
      const data = response.data.data;
      setHomeData(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHome();
  }, []);
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkWidth = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkWidth();
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, []);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const visibleCardsCount = isMobile ? 1 : 4;
  const slidesTeams = chunkArray(homeData?.teams || [], visibleCardsCount);

  const isRTL = i18n.language === "ar";

  return (
    <div className="inter-font layout-wrapper">
      <div
        className="inter-font left-strip"
        style={{
          marginLeft: isRTL ? "0" : "1%",
          marginRight: isRTL ? "1%" : "0",
        }}
      >
        {[...Array(25)].map((_, i) => (
          <img
            key={i}
            src={decoration}
            alt="Decoration"
            className="inter-font strip-icon"
          />
        ))}
      </div>
      <div
        className="inter-font main-bg"
        style={{
          minHeight: "100vh",
        }}
      >
        {/* Navbar */}
        <Header />

        {/* Banner Sec */}
        <div className="inter-font header-banner mb-5" id="home">
          <div
            className="inter-font container-fluid banner-txt"
            style={{ paddingTop: "140px", paddingBottom: "80px" }}
          >
            <h1
              className={`text-center fw-bolder res-size ${i18n.language === "ar" ? "font-iwanzaza" : "font-dishcek"}`}
              style={{ fontSize: "70px" }}
            >
              {t("h_main_title.part1")}
              <img
                src={rocket}
                className="inter-font ms-2 rocket-animation"
                style={{ width: "35px" }}
                alt="rocket"
              />
            </h1>
            <p
              className={`text-center fw-bold p-size ${i18n.language === "ar" ? "font-iwanzaza" : "font-dishcek"}`}
            >
              {t("h_main_second_line.part1")}
              <br
                className={`${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"} break`}
              />
              {t("h_main_second_line.part2")}
            </p>
          </div>
        </div>

        <div className="inter-font container border-layer1 bg-white main-bg rounded-5">
          <div className="inter-font border-layer2 rounded-bottom-5">
            <div className="inter-font row">
              <div className="inter-font col-md-6">
                <div
                  className="inter-font vision-box p-5 text-white rounded-5 m-5"
                  style={{
                    backgroundColor: "#6D5F27",
                    textAlign: isRTL ? "right" : "left",
                  }}
                >
                  <Slider ref={sliderRef} {...settings}>
                    {slides.map((slide, index) => (
                      <div key={index}>
                        <h6 className="inter-font fw-lighter">
                          {t(slide.title)}
                        </h6>
                        <h4 className="inter-font fw-bold">{t(slide.heading)}</h4>
                        <p className="inter-font fw-lighter" style={{ whiteSpace: "pre-line" }}>
                          {t(slide.description)}  
                        </p>
                      </div>
                    ))}
                  </Slider>
                  <div
                    className="inter-font d-flex justify-content-end arrows"
                    style={{ direction: "ltr" }}
                  >
                    <img
                      src={arrowLeft}
                      alt="Arrow Left"
                      className="inter-font rounded-5 arrow1"
                      style={{ cursor: "pointer", direction: "ltr" }}
                      onClick={() => sliderRef.current?.slickPrev()}
                    />
                    <img
                      src={arrowRight}
                      alt="Arrow Right"
                      className="inter-font rounded-5 arrow2 ms-2"
                      style={{ cursor: "pointer", direction: "ltr" }}
                      onClick={() => sliderRef.current?.slickNext()}
                    />
                  </div>
                </div>
              </div>
              <div className="inter-font col-md-6">
                <div className="inter-font about-us-content p-5">
                  <h4
                    className="inter-font fw-light"
                    style={{ color: "#E78E7B" }}
                  >
                    {t("about_us")}
                  </h4>

                  <h2 className="inter-font fw-bold">
                    {t("a_s2_title_line1")} <br /> {t("a_s2_title_line2")}
                  </h2>
                  <p className="inter-font fw-lighter">{t("a_s2_dec")}</p>
                </div>
              </div>
              {/* <div className="inter-font nmbs">
                <div
                  className="inter-font details text-white d-flex justify-content-center align-items-center mb-3 py-4 rounded-4 mx-5"
                  style={{ backgroundColor: "#411318" }}
                >
                  <div className="inter-font col-md-3 col-sm-6">
                    <div className="inter-font talents-found">
                      <h2>
                        <CountUp end={8950} duration={3} separator="," />
                      </h2>
                      <p>{t("a_s2_num1")}</p>
                    </div>
                  </div>

                  <div className="inter-font col-md-3 col-sm-6">
                    <div className="inter-font talents-found mx-4">
                      <h2>
                        <CountUp end={1650} duration={3} separator="," />
                      </h2>
                      <p>{t("a_s2_num2")}</p>
                    </div>
                  </div>

                  <div className="inter-font col-md-3 col-sm-6 no-longer">
                    <div className="inter-font talents-found mx-4">
                      <h2>
                        <CountUp end={4506} duration={3} separator="," />
                      </h2>
                      <p>{t("a_s2_num3")}</p>
                    </div>
                  </div>

                  <div className="inter-font col-md-3 col-sm-6 no-longer">
                    <div className="inter-font talents-found mx-4">
                      <h2>
                        <CountUp end={15} duration={3} suffix="Y" />
                      </h2>
                      <p>{t("a_s2_num4")}</p>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Us */}

      <div className="inter-font container main-bg pt-5">
        {/* Heading */}
        <div className="text-center">
          <h1 className="fw-bold">{t("why_choose")}</h1>
          <p
            style={{
              color: "#383636",
              fontSize: "1.1rem",
              lineHeight: "1.6",
            }}
          >
            {t("a_s3_dec_line1")} {t("a_s3_dec_line2")}
          </p>
        </div>

        {/* Content Blocks */}
        <div className={`row justify-content-center align-items-center mt-5 ${i18n.language === 'ar' ? 'text-md-end' : 'text-md-start'} text-center`}>
          {/* Left Text */}
          <div className="col-md-5 d-flex flex-column justify-content-center align-items-md-start align-items-center">
            <h4 className="fw-bold mb-3">{t("a_s3_opt1_title")}</h4>
            <p>
              {t("a_s3_opt1_dec_line1")} {t("a_s3_opt1_dec_line2")} {t("a_s3_opt1_dec_line3")}
            </p>
          </div>

          {/* Right Image */}
          <div className="col-md-5 d-flex justify-content-md-start justify-content-center flex-column">
            <img
              src={whyChoose1}
              className=" img-fluid"
              style={{
                borderRadius: "40px",
                maxWidth: "100%",
                height: "278px",
                objectFit: "cover",
              }}
              alt="True Talents"
            />
          </div>
        </div>

        {/* Second Row */}
        <div className={`row justify-content-center align-items-center mt-5 ${i18n.language === 'ar' ? 'text-md-end' : 'text-md-start'} text-center`}>
          {/* Left Image */}
          <div className="col-md-5 d-flex justify-content-md-start justify-content-center mb-4 mb-md-0">
            <img
              src={whyChoose2}
              alt="Our Services"
              className="img-fluid"
              style={{
                borderRadius: "40px",
                width: "100%",
                height: "279px",
                objectFit: "cover",
              }}
            />
          </div>

          {/* Right Text */}
          <div className="col-md-5 d-flex flex-column justify-content-center align-items-md-start align-items-center">
            <h3 className="fw-bold mb-3">{t("a_s3_opt2_title")}</h3>
            <p>{t("a_s3_opt2_dec")}</p>

            {[
              t("a_s3_opt2_opt1"),
              t("a_s3_opt2_opt2"),
              t("a_s3_opt2_opt3"),
              t("a_s3_opt2_opt4"),
            ].map((text, index) => (
              <div key={index} className="d-flex align-items-center my-2">
                <img
                  src={tick}
                  alt="Tick"
                  className={`rounded-5 tick  ${isRTL ? "me-2" : "ms-2"} `}
                  style={{ width: "20px", height: "20px" }}
                />
                <p className="mb-0">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Talents */}

      <div className="inter-font container position-relative" id="talents">
        <div
          className="inter-font top places-main rounded-5 p-4"
          style={{ backgroundColor: "#E98266", minHeight: "500px" }}
          id="places"
        >
          <div
            className="inter-font places-text mb-2 mb-md-0"
            style={{ marginTop: "60px" }}
            data-aos="zoom-out"
          >
            <h1
              className=" text-white fw-bold text-center"
              style={{ fontFamily: "Sofia Sans, sans-seri" }}
            >
              {t("a_s4_title")}
            </h1>
            <p
              className="inter-font text-center text-white"
              style={{ fontFamily: "Sofia Sans, sans-seri" }}
            >
              {t("a_s4_dec_line1")}
              {/* <br /> */}
              {t("a_s4_dec_line2")}
              <br />
              {t("a_s4_dec_line3")}
            </p>
          </div>

          {/* <div className="inter-font" style={{ background: "#E57B63", padding: "40px 0" }}>
  <div style={{ maxWidth: "1240px", margin: "0 auto" }}>
    <Slider ref={teamSliderRef} {...teamSettings}>
      {homeData?.teams?.map((talent, index) => (
        <div key={index} className="team-card-wrapper">
          <div
            style={{
              backgroundColor: "#fff0",
              borderRadius: "30px",
              padding: "20px 10px",
              textAlign: "center",
            }}
          >

            <div
              style={{
                width: "180px",
                height: "180px",
                borderRadius: "50%",
                overflow: "hidden",
                margin: "0 auto 15px auto",
              }}
            >
              {talent.image ? (
                <img
                  src={talent.image}
                  alt={talent.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <User className="w-100 h-100 rounded-circle" />
              )}
            </div>


            <h5
              style={{
                fontWeight: "bold",
                color: "#fff",
                marginBottom: "5px",
                fontSize: "20px",
              }}
            >
              {talent.name}
            </h5>


            <p style={{ color: "#fff", fontSize: "16px", margin: 0 }}>
              {talent.position}
            </p>
          </div>
        </div>
      ))}
    </Slider>
  </div>
</div> */}
          {/* <div className="inter-font row  mt-3" style={{gap:"20px"}}>
            <div className="inter-font d-flex justify-content-center align-items-center flex-nowrap team-container">
              {homeData?.teams?.map((talent, index) => (
                <div key={index} className="inter-font px-3 card-person me-2 rounded-5">
                  <div className="inter-font d-flex">
                    <div className="inter-font text-center mb-3">
                      <div
                        className="inter-font rounded-circle overflow-hidden mx-auto mb-2 meetOurTeam"
                        style={{ width: "200px", height: "200px" }}
                      >
                        <img
                          src={talent.image}
                          alt={talent.name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <h6 className="inter-font text-white mb-0 talent-name-size">
                        {talent.name}
                      </h6>
                      <small className="inter-font text-white">{talent.position}</small>
                    </div>
                  </div>
                </div>
              ))}
            </div>

</div> */}

          <Carousel
            activeIndex={index}
            onSelect={handleSelect}
            indicators={false}
            controls={homeData?.teams?.length > visibleCardsCount}
            interval={null} // no auto-slide unless you want
            className="inter-font mt-3"
          >
            {slidesTeams.map((slide, idx) => (
              <Carousel.Item key={idx}>
                <div className="d-flex justify-content-center gap-3 flex-wrap">
                  {slide.map((talent, index) => (
                    <div
                      key={index}
                      className="inter-font px-3 card-person me-2 rounded-5"
                      style={{ flex: "0 0 auto" }}
                      onClick={() => {
                        setSelectedMember(talent);
                        setShowModal(true);
                      }}
                    >
                      <div className="d-flex">
                        <div className="text-center mb-3">
                          <div
                            className="rounded-circle overflow-hidden mx-auto mb-2 meetOurTeam"
                            style={{ width: "200px", height: "200px" }}
                          >
                            <img
                              src={talent.image}
                              alt={talent.name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                          <h6
                            className={`text-white mb-0 talent-name-size ${i18n.language === "ar" ? "font-iwanzaza" : "font-dishcek"}`}
                          >
                            {i18n.language === "ar"
                              ? talent.name_ar || talent.name
                              : talent.name}
                          </h6>
                          <small
                            className={`text-white ${i18n.language === "ar" ? "font-iwanzaza" : "font-dishcek"}`}
                          >
                            {i18n.language === "ar"
                              ? talent.position_ar || talent.position
                              : talent.position}
                          </small>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            centered
            size="lg"
            dir={isRTL ? "rtl" : "ltr"}
          >
            <Modal.Header
              closeButton
              style={{
                direction: isRTL ? "rtl" : "ltr",
              }}
              className={isRTL ? "pe-4 ps-2" : ""}
            >
              <Modal.Title
                className={`${i18n.language === "ar" ? "font-iwanzaza" : "font-dishcek"}`}
                style={{
                  fontWeight: 400,
                  textAlign: isRTL ? "right" : "left",
                  width: "100%",
                }}
              >
                {isRTL
                  ? `تواصل معنا ${selectedMember ? `مع ${selectedMember.name_ar || selectedMember.name}` : ""}`
                  : `Get in Touch ${selectedMember ? `with ${selectedMember.name}` : ""}`}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form
                className={`bg-white custom-form ${i18n.language === "ar" ? "font-iwanzaza" : "font-dishcek"}`}
                style={{
                  borderRadius: "40px",
                  padding: "30px",
                  fontWeight: 400,
                  textAlign: isRTL ? "right" : "left",
                }}
                onSubmit={handleSubmit}
              >
                {/* Name */}
                <Form.Group className="mb-3">
                  <Form.Label>
                    <strong>
                      {t("h_text3")} <span className="text-danger">*</span>
                    </strong>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={isRTL ? "الاسم..." : "Name..."}
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    isInvalid={!!errors.name}
                    style={{
                      textAlign: isRTL ? "right" : "left",
                      direction: isRTL ? "rtl" : "ltr",
                    }}
                  />
                  {errors.name && (
                    <div className="text-danger mt-1">{errors.name}</div>
                  )}
                </Form.Group>

                {/* Email */}
                <Form.Group className="mb-3">
                  <Form.Label>
                    <strong>
                      {t("h_text4")} <span className="text-danger">*</span>
                    </strong>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder={isRTL ? "البريد الإلكتروني..." : "Email..."}
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    isInvalid={!!errors.email}
                    style={{
                      textAlign: isRTL ? "right" : "left",
                      direction: "ltr", // Keep email LTR always
                    }}
                  />
                  {errors.email && (
                    <div className="text-danger mt-1">{errors.email}</div>
                  )}
                </Form.Group>

                {/* Message */}
                <Form.Group className="mb-3">
                  <Form.Label>
                    <strong>
                      {t("h_text9")} <span className="text-danger">*</span>
                    </strong>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    placeholder={
                      isRTL ? "اكتب رسالتك..." : "Write your message..."
                    }
                    value={formData.message}
                    onChange={(e) =>
                      setFormData({ ...formData, message: e.target.value })
                    }
                    isInvalid={!!errors.message}
                    style={{
                      textAlign: isRTL ? "right" : "left",
                      direction: isRTL ? "rtl" : "ltr",
                    }}
                  />
                  {errors.message && (
                    <div className="text-danger mt-1">{errors.message}</div>
                  )}
                </Form.Group>

                <button
                  className={`btn btn-base fw-bold mt-3 ${i18n.language === "ar" ? "font-iwanzaza" : "font-dishcek"}`}
                  type="submit"
                  disabled={
                    !formData.name.trim() ||
                    !formData.email.trim() ||
                    !isValidEmail(formData.email) ||
                    !formData.message.trim()
                  }
                >
                  {isRTL ? "إرسال" : "Submit"} <MdArrowOutward fontSize={20} />
                </button>
              </Form>
            </Modal.Body>
          </Modal>
          {showSuccessModal && (
            <div
              className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25 zindex"
              style={{ backdropFilter: "blur(2px)" }}
              onClick={() => setShowSuccessModal(false)}
            >
              <div
                className="bg-white text-center p-4 rounded-4 shadow"
                style={{
                  maxWidth: 500,
                  width: "90%",
                  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                  animation: "scaleIn 0.3s ease-out",
                  direction: isRTL ? "rtl" : "ltr",
                }}
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
              >
                <div className="mb-3">
                  <div
                    className="mx-auto d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: "#32C769",
                      width: 60,
                      height: 60,
                      borderRadius: "50%",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      fill="white"
                      className="bi bi-check-lg"
                      viewBox="0 0 16 16"
                    >
                      <path d="M13.485 1.929a.75.75 0 0 1 1.03 1.092l-8 9a.75.75 0 0 1-1.08.02l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 7.52-8.522z" />
                    </svg>
                  </div>
                </div>

                {/* Text */}
                <h5
                  className={`fw-bold mb-2 ${i18n.language === "ar" ? "font-iwanzaza" : "font-dishcek"}`}
                  style={{ fontWeight: 400 }}
                >
                  {t("h_text1")} {/* "Thank You!" */}
                </h5>
                <p
                  className={`text-secondary mb-4 ${i18n.language === "ar" ? "font-iwanzaza" : "font-dishcek"}`}
                  style={{ fontSize: 14, fontWeight: 400 }}
                >
                  {selectedMember
                    ? t("inquiry_received_with_name", {
                        name: isRTL
                          ? selectedMember.name_ar || selectedMember.name
                          : selectedMember.name,
                      })
                    : t("inquiry_received_generic")}
                </p>

                {/* Button */}
                <button
                  className={`border-0 text-white fw-medium px-5 py-2 ${i18n.language === "ar" ? "font-iwanzaza" : "font-dishcek"}`}
                  style={{
                    backgroundColor: "#FF5C35",
                    borderRadius: "999px",
                    fontSize: 16,
                    fontWeight: 400,
                  }}
                  onClick={() => setShowSuccessModal(false)}
                >
                  {t("c_t_close")} {/* "Close" */}
                </button>
              </div>

              {/* Animation Styles */}
              <style>{`
      @keyframes scaleIn {
        from { transform: scale(0.9); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
    `}</style>
            </div>
          )}
        </div>
        <div className="inter-font design-i">
          <img src={design} />
        </div>
      </div>

      {/* Want To Hire */}
      <div
        className="inter-font container top want-hire p-4 d-flex justify-content-center align-items-center position-relative text-white"
        style={{
          backgroundColor: "#411318",
          minHeight: "404px",
          flexDirection: "column",
          height: "405px",
          borderRadius: "40px",
          marginBottom: "100px",
        }}
        id="places"
      >
        <div>
          <h1
            className={`fw-bolder text-center ${i18n.language === "ar" ? "font-iwanzaza" : "font-dishcek"}`}
            style={{ fontSize: "3.5rem" }}
          >
            {t("h_s6_title_line1")}
            <br className="inter-font break" />
            {t("h_s6_title_line2")}{" "}
          </h1>
        </div>

        <button
          className={`btn btn-base fw-bold me-2 mt-3 ${i18n.language === "ar" ? "font-iwanzaza" : "font-dishcek"}`}
          onClick={() => navigate("/company")}
        >
          {t("h_s6_btn")} <MdArrowOutward fontSize={20} />
        </button>
        <div className="design-i">
          <img src={design} />
        </div>

        <div className="inter-font talents">
          <img src={person1} className="inter-font person1" />
          <img src={person2} className="inter-font person2" />
          <img src={person3} className="inter-font person3" />
        </div>

      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AboutUs;
